import { Grid } from "@mui/material";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import Button from "../../../framework/Button";
import GlobalContext from "../../../framework/GlobalContext";
import Shortcut from "../../../framework/Shortcut";
import TextInput from "../../../framework/TextInput";
import { displayToast } from "../../../framework/toast/toastUtils";
import { formStateHandler, isEmpty } from "../../../utils/utils";
import classes from "./index.module.css";
import { saveProfession } from "../../../services/doctor-service";

const EditProfession = ({
  professionData,
  onSaveProfession = () => {},
  onEscape = () => {},
}) => {
  // const {
  //   focusElement,
  // } = useContext(GlobalContext);
  const [formState, setFormState] = useState({});
  const professionNameRef = useRef("");
  const saveProfessionRef = useRef();
  const { setCurrentComponent } = useContext(GlobalContext);

  const validateForm = useCallback((formState) => {
    if (!formState?.professionName?.trim()) {
      displayToast({
        type: "error",
        title: "Please enter profession name.",
      });
      professionNameRef.current?.focus();
      return;
    }
    return true;
  }, []);
  useEffect(() => {
    if (professionData) {
      setFormState({
        professionName: professionData.name || "",
        id: professionData.professionId || null,
      });
    }
  }, [professionData]);
  useEffect(() => {
    professionNameRef.current?.focus();
  },[]);
  const updateProfessionHandler = useCallback(
    async (e) => {
      if (!(await validateForm(formState))) return;
      const professionPayload = {
        professionId: formState.id,
        name: formState.professionName,
      };
      return saveProfession(professionPayload).then((r) => {
        onSaveProfession();
        return displayToast({
          type: "success",
          title: "Profession updated successfully.",
        });
      });
    },
    [formState, onSaveProfession, validateForm]
  );
  const keyupListener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      if (key === "escape") {
        return onEscape();
      }
      if (event.ctrlKey && key === "s") {
        return saveProfessionRef.current.click();
      }
    },
    [onEscape]
  );

  useEffect(() => {
    document.addEventListener("keyup", keyupListener, false);
    return () => {
      document.removeEventListener("keyup", keyupListener, false);
    };
  }, [keyupListener]);
  return (
    <div>
      <h4 className={classes["profession-detail-label"]}>Profession Details</h4>
      <Grid container spacing={2} sx={{ p: "25px 20px" }}>
        <Grid item xs={12}>
          <TextInput
            id="profession_name"
            ref={professionNameRef}
            name="professionName"
            label="Profession Name"
            value={formState?.professionName || ""}
            onFocus={() => setCurrentComponent("profession_name")}
            onChange={(e) => {
              setFormState((prev) => {
                return {
                  ...prev,
                  professionName: e.target.value,
                };
              });
            }}
            onBlur={() => validateForm("professionName", formState)}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "profession_name",
                down: "edit_profession_save_button",
                left: "profession_name",
                right: "edit_profession_save_button",
              }),
            }}
          />
        </Grid>
      </Grid>
      <div className={classes["edit-profession-save-button-wrapper"]}>
        <Button
          id="edit_profession_save_button"
          ref={saveProfessionRef}
          endIcon={<Shortcut keys={["Ctrl", "S"]} />}
          label="Save Profession"
          color="violet"
          onClick={updateProfessionHandler}
          markers={JSON.stringify({
            up: "profession_name",
            left: "profession_name",
            right: "edit_profession_save_button",
            down: "edit_profession_save_button",
          })}
        />
      </div>
    </div>
  );
};

export default EditProfession;
